import React, { FC } from 'react';

export const PageNotFound: FC = () => {
	return <div>Page Not Found!</div>;
};

